import HeaderSubSection from "../../components/HeaderSubSection/index.vue";

export default {
  name: "conditionsPage",
  components: {
    HeaderSubSection,
  },
};
